import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledErrorCard = styled.div`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    min-height: 280px;
    margin-bottom: 40px;
    text-align: center;
    padding-top: 16px;
    padding-bottom: 16px;
    background: var(--color-grey-600);
    border-radius: var(--radius-10);
    margin-top: 30px;
    @media ${breakpoints.sm} {
        margin-bottom: 32px;
    }
`;

export const StyledErrorWrapper = styled.div`
    width: auto;
    max-width: 50%;
    margin: 0 auto;
    @media ${breakpoints.sm} {
        max-width: 70%;
    }
`;

export const StyledErrorTitle = styled.div`
    font-size: var(--size-18);
    font-weight: bold;
    color: var(--color-primary);
`;

export const StyledErrorInfo = styled.div`
    margin: 2rem 0 3rem 0;
    font-size: var(--size-16);
    color: var(--color-grey-800);
`;
